import React, { useEffect, useState } from "react";
import {
  Typography,
  Paper,
  Box,
  CircularProgress,
  Container,
  Link,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { cancelSubscription } from "../../utils/subscriptionUtils";

const Unsubscribe = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const actionCancelSubscription = async () => {
    try {
      setLoading(true);
      await cancelSubscription();
    } catch (error) {
      console.error("Error:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    actionCancelSubscription();
  }, []);

  // Render loading state
  if (loading) {
    return (
      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <CircularProgress size={60} sx={{ mb: 2 }} />
          <Typography variant="h6">{t("unsubscribe.loading")}</Typography>
        </Box>
      </Container>
    );
  }

  // Render error state
  if (error) {
    return (
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            p: 3,
            textAlign: "center",
            backgroundColor: (theme) => theme.palette.error.light,
            color: (theme) => theme.palette.error.contrastText,
          }}
        >
          <Typography variant="h5" gutterBottom>
            {t("unsubscribe.errorTitle")}
          </Typography>
          <Typography variant="body1">{error}</Typography>
        </Paper>
      </Container>
    );
  }

  // Render success state
  return (
    <Container maxWidth="sm">
      <Paper
        elevation={3}
        sx={{
          p: 4,
          textAlign: "center",
        }}
      >
        <Typography variant="h4" color="primary" gutterBottom>
          {t("unsubscribe.title")}
        </Typography>
        <Typography variant="body1" align="justify" component={"p"}>
          {t("unsubscribe.message")}
        </Typography>
        <Box sx={{ pt: 2, display: "flex" }}>
          <Typography sx={{ pr: 1 }} variant="body1">
            {t("support.haveQuestions")}
          </Typography>
          <Link
            target="_blank"
            href={process.env.REACT_APP_SUPPORT_PAGE}
            variant="body1"
          >
            {t("support.visitSite")}
          </Link>
        </Box>
      </Paper>
    </Container>
  );
};

export default Unsubscribe;
